module.exports = (fox) => {
	const $ = fox.jQuery;
	const formValidationMixin = require('./mixin/formvalidation')(fox);

	fox.registerWidget('Common_GuestPurchasePopup', fox.mixin({
		configure() {
			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false,
					width: '482px'
				},
				widgets: {
					content: {
						template: 'common_guest_purchase_popup',
						widgets: {
							form: {
								widget: 'DomForm',
								formSelector: '#store-reg-form',
								elements: {
									email: {
										validators: [
											{ validator: 'regexp', options: { type: 'email' }, message: 'Email address is invalid' }
										]
									}
								},
								'handleWom.formValid': {
									widget: '@this',
									event: ['form_valid', 'form_not_valid'],
									callback: (...args) => this.formInvalidate(...args)
								}
							}
						},
						'handleDom.focus': {
							target: 'input',
							event: 'focus',
							callback: el => $(el.parentNode).removeClass('error')
						}
					}
				},
				handleDom: {
					purchase: {
						target: '#purchase',
						targetWidget: '#content',
						callback: (...args) => this.purchase(...args)
					},
					cancel: {
						target: ['#cancel', '.cross.close'],
						targetWidget: '#content',
						callback: (...args) => this.cancel(...args)
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init() {
			this.registerOptions('#content', {
				'templateOptions.template': this.getOption('contentTemplate')
			});

			this.callParent('init', arguments);
		},

		show(...args) {
			return new fox.Promise(resolve => {
				this.__resolver = resolve;
				this.callParent('show', args);
			});
		},

		purchase(button) {
			const form = this.rwom1('#content #form');
			return form.submit().then(result => {
				if (!result)
					return false;

				this.hide();
				form.reset();
				return this.__resolver({
					result,
					button
				});
			});
		},

		cancel(...args) {
			return this.__resolver(false);
		}
	}, formValidationMixin), 'Popup_Common');
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/widget/GuestPurchasePopup.es.js